import { render, staticRenderFns } from "./OrderCalendarFullDay.vue?vue&type=template&id=8b2b22ac&scoped=true&"
import script from "./OrderCalendarFullDay.vue?vue&type=script&lang=js&"
export * from "./OrderCalendarFullDay.vue?vue&type=script&lang=js&"
import style0 from "./OrderCalendarFullDay.vue?vue&type=style&index=0&id=8b2b22ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2b22ac",
  null
  
)

export default component.exports